export const VARIANCE_REPORTING_TITLE = 'Variance Reporting';
export const VARIANCE_REPORT_STATUS_URL = 'variance-report-status';
export const VARIANCE_REPORTING_URL = 'variance-reporting';
